import product from './product';

export default {
  init() {
    // JavaScript to be fired on all pages
    
    // Fallback: Initialize product page handler if cart form exists
    // This ensures it works even if Router doesn't match the route
    if (jQuery('form.cart').length > 0 && jQuery('body').hasClass('single-product')) {
      product.init();
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Change modal content when opening modal
    $('#modal').on('show.bs.modal', function(e) {
      var button = $(e.relatedTarget);
      var title = button.data('title') ? button.data('title') : '';
      var content = JSON.parse(button.data('content'));
      var modal = $(this);
      modal.find('.modal-header').prepend('<h5 class="modal-title" id="modalLabel">' + title + '</h5>');
      modal.find('.modal-body').html(content);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'UAevent',
        'eventCategory': 'modalopen',
        'eventAction': title,
        'eventLabel': window.location.href, 
        'eventValue': undefined,
      });
    });

    // Remove modal content after its hidden
    $('#modal').on('hidden.bs.modal', function() {
      var modal = $(this);
      modal.find('.modal-title').remove();
      modal.find('.modal-body').html('');
    });

    if ($('#addtocartmodal').length) {
      $('#addtocartmodal').modal('show');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js